import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import {
  DSButton,
  DSCardWrapper,
} from "@components/design-system/molecules";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { saveAs } from "file-saver";
import mixpanel from "mixpanel-browser";
import React, { useState } from "react";

import { alert } from "../common/Alert";
import NoteCreatedAt from "../notebook/note/NoteCreatedAt";

const GET_AUDIT_TRAIL = gql`
  query auditTrail($uuid: String) {
    auditTrail(uuid: $uuid) {
      uuid
      fileLink
    }
  }
`;

export function AuditTrailListItem({ audit }) {
  const [isDownloadRequested, setIsDownloadRequested] =
    useState(false);
  const [auditTrail] = useLazyQuery(GET_AUDIT_TRAIL);

  const handleDownload = async () => {
    setIsDownloadRequested(true);
    try {
      const { data } = await auditTrail({
        variables: {
          uuid: audit.uuid,
        },
      });
      const fileLink = data?.auditTrail?.fileLink;
      if (fileLink) {
        saveAs(fileLink, audit.fileName);
      } else {
        alert("error", "File is no longer available for download.");
      }
    } catch (error) {
      alert("error", "Failed to download the audit trail.");
      mixpanel.track("Audit Trail Download Failed", {
        auditUuid: audit.uuid,
        error: error?.message || String(error),
      });
    } finally {
      setIsDownloadRequested(false);
    }
  };

  return (
    <DSCardWrapper dataTestId="audit-trail-list-item" padding="p-3">
      <div className="flex flex-row items-center justify-between space-x-4">
        <NoteCreatedAt createdAt={audit.createdAt} />
        <DSButton
          variant="secondary"
          size="sm"
          icon={faFileDownload}
          disabled={isDownloadRequested}
          onClick={handleDownload}
          dataTestId="audit-trail-download-button"
        >
          {audit.fileName}
        </DSButton>
      </div>
    </DSCardWrapper>
  );
}
